import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";
import { useHistory } from "react-router-dom";
import {
  getSetupDetails,
  saveRequestApi,
  saveSetupWizardForm,
} from "../../../Redux/actions";
import SWInterface from "../../Components/Layout/SWInterface";

const SetupWizard = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { setup_wizard_details } = useSelector((state) => state.authReducer);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planCostId, setPlanCostId] = useState(1);
  const [posPlan, setPosPlan] = useState(1);
  const [isOrdrr, setIsOrdrr] = useState(false);

  useEffect(() => {
    dispatch(getSetupDetails());
  }, []);
  useEffect(() => {
    if (
      setup_wizard_details?.pos_plans &&
      setup_wizard_details?.pos_plans.length > 0
    ) {
      setPlans(setup_wizard_details?.pos_plans);
      setSelectedPlan(setup_wizard_details?.pos_plans?.[0]);
    }
  }, [setup_wizard_details]);

  const getPlanId = () => {
    let res = 1;
    const account =
      setup_wizard_details?.account && setup_wizard_details?.account !== null
        ? setup_wizard_details?.account
        : null;
    if (
      account?.merchant?.pos_plan_cost_id &&
      (account?.merchant?.pos_plan_cost_id == 3 ||
        account?.merchant?.pos_plan_cost_id == 4)
    ) {
      res = 2;
    }
    return res;
  };

  const planCostChangeHandler = (event) => {
    setPlanCostId(event?.target?.value);
    let checkPosPlan = 1;
    if (event?.target?.value == 1) {
      //monthly
      if (selectedPlan?.id == plans?.[1]?.id) {
        checkPosPlan = 3;
      }
    } else if (event?.target?.value == 2) {
      //yearly
      if (selectedPlan?.id == plans?.[0]?.id) {
        checkPosPlan = 2;
      } else {
        checkPosPlan = 4;
      }
    }
    setPosPlan(checkPosPlan);
  };

  const getTotalCost = (type = "month") => {
    let res = 0;
    if (type == "month") {
      res = parseFloat(selectedPlan?.pos_plan_costs?.[0]?.cost ?? 0);
      if (isOrdrr) {
        res += 99;
      }
    } else {
      res = parseFloat(selectedPlan?.pos_plan_costs?.[1]?.cost ?? 0);
      if (isOrdrr) {
        res += 999;
      }
    }
    return res;
  };

  const saveRequestApiHandler = () => {
    dispatch(
      saveRequestApi({
        req_type: "api_request",
      })
    );
  };
  const submitButtonHandler = () => {
    const data = {
      plan_id: selectedPlan?.id,
      pos_count: 10,
      pos_plan: posPlan,
    };
    if (isOrdrr) data.is_ordrr = "on";
    dispatch(saveSetupWizardForm("zero", data));
  };

  const selectPriceContainer = (
    <section class="select-pricing_ms" id="PlanPriceBox">
      <form className="select-pricing">
        <input
          type="hidden"
          name="pos_count"
          value="10"
          class="pos_count"
          required="true"
        />
        <div class="left-sec">
          <h2 class="lg-hd"> Select Pricing </h2>
        </div>
        <div class="right-sec d-flex">
          <div class="left-col">
            <div class="monthly col">
              <p> Choose to pay monthly for... </p>
              <div class="radio-group">
                <input
                  type="radio"
                  id="monthly"
                  class="radio_plan"
                  value="1"
                  checked={planCostId == 1}
                  onClick={planCostChangeHandler}
                  name="pos_plan"
                />
                <label for="monthly">
                  {" "}
                  <strong>
                    <small>$</small>
                    <span id="MonthPrice">{getTotalCost()}</span>
                  </strong>
                  <small>/Mo</small>
                </label>
              </div>
            </div>
            <div class="yearly col">
              <p> ...or once annually for </p>
              <div class="radio-group">
                <input
                  type="radio"
                  id="yearly"
                  class="radio_plan"
                  value="2"
                  checked={planCostId == 2}
                  onClick={planCostChangeHandler}
                  name="pos_plan"
                />
                <label for="yearly">
                  {" "}
                  <strong>
                    <small>$</small>
                    <span id="YearPrice">{getTotalCost("year")}</span>
                  </strong>
                  <small>/Yr</small>
                </label>
                <em>
                  {" "}
                  <strong>BEST VALUE</strong> (16% Discount){" "}
                </em>
              </div>
            </div>
          </div>

          <div class="next-step col">
            <a href="javascript:void(0)" class="req_button">
              <h4 class="green-txt h5"> Hardware Enquiry </h4>
            </a>
            <button
              class="btn btn_btnblue posbutton"
              type="button"
              name="next"
              id="next"
              onClick={() => submitButtonHandler()}
            >
              {" "}
              Next Step
            </button>
          </div>
        </div>
      </form>
    </section>
  );

  return (
    <SWInterface step={0} selectPriceContainer={selectPriceContainer}>
      <div className="steps-content row_count2">
        <div className="steps-div_outer h-100">
          <div className="steps-div d-block">
            <form>
              <h4 className="event-alert"> Pick Your Solution </h4>
              <div className="solutions-sec">
                <div
                  className={`cate-box standard-box${
                    selectedPlan?.id == plans?.[0]?.id ? " active" : " inactive"
                  }`}
                  onClick={() => {
                    if (plans?.[0]) {
                      setSelectedPlan(plans?.[0]);
                    }
                  }}
                >
                  <span className="green-btns">
                    {" "}
                    {plans?.[0]?.name ?? "N/A"}{" "}
                  </span>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="purple-txt">erp</span>go
                  </h2>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="green-txt">pos</span>go
                  </h2>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="yellow-txt">hr</span>go
                  </h2>
                  <h2 className="lg-title"> - </h2>

                  <hr />
                  <div className="price-sec">
                    <h2 className="price">
                      {" "}
                      $ {parseFloat(
                        plans?.[0]?.pos_plan_costs?.[0]?.cost ?? 0
                      )}{" "}
                    </h2>
                    /MTH
                  </div>
                  <p>
                    {" "}
                    OR ${" "}
                    {parseFloat(plans?.[0]?.pos_plan_costs?.[1]?.cost ?? 0)}
                    /YR{" "}
                  </p>
                </div>

                <div
                  className={`cate-box gogmgo-plus-box${
                    selectedPlan?.id == plans?.[1]?.id ? " active" : " inactive"
                  }`}
                  onClick={() => {
                    if (plans?.[1]) {
                      setSelectedPlan(plans?.[1]);
                    }
                  }}
                >
                  <span className="green-btns">
                    {" "}
                    {plans?.[1]?.name ?? "N/A"}{" "}
                  </span>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="purple-txt">erp</span>go
                  </h2>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="green-txt">pos</span>go
                  </h2>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="yellow-txt">hr</span>go
                  </h2>
                  <h2 className="lg-title">
                    {" "}
                    go<span className="orng-txt">hq</span>go
                  </h2>

                  <hr />

                  <div className="price-sec">
                    <h2 className="price">
                      {" "}
                      $ {parseFloat(
                        plans?.[1]?.pos_plan_costs?.[0]?.cost ?? 0
                      )}{" "}
                    </h2>
                    /MTH
                  </div>
                  <p>
                    {" "}
                    OR ${parseFloat(plans?.[1]?.pos_plan_costs?.[1]?.cost ?? 0)}
                    /YR{" "}
                  </p>
                  {parse(plans?.[1]?.desc ?? "<p>N/A</p>")}
                </div>

                <div className="add-ons">
                  <span className="green-btns">
                    {" "}
                    {plans?.[2]?.name ?? "N/A"}{" "}
                  </span>
                  <h2 className="lg-title ordrr-sec">
                    {" "}
                    ordr<span className="pink-txt">r</span>
                  </h2>
                  <p>{plans?.[2]?.desc ?? "N/A"}</p>
                  <div className="price-sec">
                    <h4 className="price-sm">
                      ${parseFloat(plans?.[2]?.pos_plan_costs?.[0]?.cost ?? 0)}
                    </h4>
                    <small>/MTH</small>
                  </div>
                  <p className="sm-txt">
                    {" "}
                    OR ${parseFloat(plans?.[2]?.pos_plan_costs?.[1]?.cost ?? 0)}
                    /YR{" "}
                  </p>

                  <div className="btn bordered-btn add-btn">
                    <input
                      type="checkbox"
                      className="checkbox"
                      id="ordrr"
                      name="is_ordrr"
                      checked={isOrdrr}
                      onClick={() => setIsOrdrr(!isOrdrr)}
                    />{" "}
                    <label for="ordrr" id="addlbl">
                      {" "}
                      {isOrdrr ? "Remove" : "Add"}
                    </label>
                  </div>

                  <hr />

                  <h2 className="lg-title">
                    {" "}
                    go<span className="pink-txt">link</span>go
                  </h2>
                  <p>{plans?.[3]?.desc ?? "N/A"}</p>
                  <div className="price-sec">
                    <h4 className="price-sm">
                      ${parseFloat(plans?.[3]?.pos_plan_costs?.[0]?.cost ?? 0)}
                    </h4>
                    <small>/MTH</small>
                  </div>
                  <p className="sm-txt">
                    {" "}
                    OR ${parseFloat(plans?.[3]?.pos_plan_costs?.[1]?.cost ?? 0)}
                    /YR <em>(PER PACK)</em>{" "}
                  </p>

                  <button
                    type="button"
                    className="btn bordered-btn request-btn"
                    onClick={() => saveRequestApiHandler()}
                  >
                    {" "}
                    Request{" "}
                  </button>
                </div>
                <input
                  type="hidden"
                  name="plan_id"
                  id="planid"
                  value={getPlanId()}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizard;
